import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{#in-element this.messagesNav}}\n  {{yield}}\n{{/in-element}}",{ moduleName: "discourse/components/user-nav/messages-secondary-nav.hbs" })